import { jumboMediaAPI } from "./service";

// API slice for working with encrypted emails for current user
// Backend endpoint: GET /api/EncryptedEmails/UserGet
// It reads user email from bearer token and returns encrypted value
export const encryptedEmailsAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    getEncryptedEmailForCurrentUser: build.query<any, void>({
      query: () => ({
        url: `/api/EncryptedEmails/UserGet`,
      }),
    }),
  }),
});

export const {
  useLazyGetEncryptedEmailForCurrentUserQuery,
} = encryptedEmailsAPI;


